import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

function EditPettyCashUserModal(props) {
  const [u_name, setUname] = useState(props.editData.name);

  const updatePettyCashUserHandler = (e) => {
    let body = {
      id:props.editData.id,
      name: u_name.trim()
    };
    PostApiWithAuthorizationAction("common/edit-petty-cash-user-render-data", body)
      .then((res) => {
        //toast.success(res.message);
        props.addUpdatedData(res.data);
        props.toggle();
      })
      .catch((err) => {
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        } 
      });
  };
  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Update User Details</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="form-control-label" for="u_name">
          User Name
          </Label>
          <Input
          id="u_name"
            type="text"
            placeholder="User Name"
            value={u_name}
            onChange={(e) => setUname(e.target.value)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button
        id="update-btn"
          color="primary"
          onClick={updatePettyCashUserHandler}
          disabled={u_name.length === 0}
        >
          Update
        </Button>{" "}
        <Button color="secondary" onClick={props.toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditPettyCashUserModal;
